import { connect, FormikProps } from 'formik';
import React from 'react';
import { DFErrors, DFormState, DFTouched, DFValues } from './types';

interface OuterProps {
  onChange: (nextState: DFormState, prevState?: DFormState) => void;
  validateOnLoad: boolean;
}

type Props = OuterProps & { formik: FormikProps<DFValues> };

class Effects extends React.Component<Props> {
  public componentDidMount() {
    const { validateOnLoad, formik } = this.props;
    const { values, errors, touched, isValid } = formik;
    if (validateOnLoad) {
      formik.validateForm();
    }
    this.props.onChange({
      values,
      errors: errors as DFErrors,
      touched: touched as DFTouched,
      isValid
    });
  }

  public UNSAFE_componentWillReceiveProps(nextProps: Props) {
    const { values, errors, touched, isValid } = this.props.formik;
    const {
      values: nextValues,
      errors: nextErrors,
      touched: nextTouched,
      isValid: nextIsValid
    } = nextProps.formik;

    this.props.onChange(
      {
        values: nextValues,
        errors: nextErrors as DFErrors,
        touched: nextTouched as DFTouched,
        isValid: nextIsValid
      },
      {
        values,
        errors: errors as DFErrors,
        touched: touched as DFTouched,
        isValid
      }
    );
  }

  public render() {
    return null;
  }
}

export default connect<OuterProps>(Effects);
